import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { clearLocalStorageExceptLastLoginService } from '../../services/clearLocalStorageExceptLastLogin.service';

@Component({
  selector: 'app-should-login',
  templateUrl: './should-login.component.html',
  styleUrls: ['./should-login.component.scss'],
})
export class ShouldLoginComponent {
  constructor(
    private authService: OAuthService,
    private router: Router,
    private clearLocalStorageExceptLastLoginService: clearLocalStorageExceptLastLoginService
  ) {}
  public login($event: any) {
    this.clearLocalStorageExceptLastLoginService.clearLocalStorageExceptLastLogin();

    sessionStorage.clear();
    $event.preventDefault();
    this.router.navigate(['/login']);
  }
}
